import React from 'react'
import NewScreensLayout from './NewScreensLayout'

const NewScreens = () => {
  return <NewScreensLayout />
}

export default NewScreens
